import { useEffect, useState } from 'react';

import { supabase } from '../../../api';

import { Link as RouterLink } from 'react-router-dom';
import { Grid, Typography, Avatar, Box, Link } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import LanguageIcon from '@mui/icons-material/Language';
import { useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';

import VCard from '../VCard/VCard';
import VCardFileCreator from '../VCard/VCardFileCreator';
import { PROFILE_PUBLIC_CARD_TABLE } from '../../../constants/supabase_constants';

const ProfileLinks = (props) => {
  let [user, setUser] = useState({});
  let { id } = useParams();

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);

  const getUser = async () => {
    const { data: user, error } = await supabase.from(PROFILE_PUBLIC_CARD_TABLE).select('*').eq('id', id).single();
    if (error) console.log(error);
    else {
      setUser(user);
      console.log(user);
    }
  };

  if (user.avatar_url === undefined) {
    return (
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: '10rem',
          mx: 'auto',
          textAlign: 'center',
        }}>
        <Oval height='40' width='40' color='#00203F' secondaryColor='#001121' wrapperClass='mx-auto' />
      </Grid>
    );
  }

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mt: '2rem',
        mx: 'auto',
        textAlign: 'center',
      }}>
      <Avatar
        src={
          user.avatar_url
            ? `https://hnjiwdxlyyttjbocwpfw.supabase.co/storage/v1/object/public/avatars/${user.avatar_url}`
            : 'https://picsum.photos/200'
        }
        alt={user.avatar_url ? 'Avatar' : 'No image'}
        sx={{
          width: 150,
          height: 150,
          mx: 'auto',
          border: '4px solid #F6F6F6',
        }}
      />
      <Typography variant='h3' component='h1' sx={{ fontWeight: 'bold', mt: '2rem' }}>
        {user.membershipLevel === 'member' || user.membershipLevel === 'member+mentor' ? 'MEMBER' : 'NOT A MEMBER'}
      </Typography>
      <Box className='flex gap-2 justify-center mt-6'>
        <a
          href={user.linkedin}
          target='_blank'
          rel='noreferrer'
          className='bg-primary-main text-white p-3 rounded-full'>
          <LinkedInIcon />
        </a>
        <VCardFileCreator user={user} source={'icon'} />
        <a
          href={`mailto:${user.email}`}
          target='_blank'
          rel='noreferrer'
          className='bg-primary-main text-white p-3 rounded-full'>
          <AlternateEmailIcon />
        </a>
        <a
          href={user.companyLink}
          target='_blank'
          rel='noreferrer'
          className='bg-primary-main text-white p-3 rounded-full'>
          <LanguageIcon />
        </a>
      </Box>
      <Box>
        <Grid
          container
          spacing={0}
          direction='column'
          alignItems='center'
          justifyContent='center'
          style={{ marginTop: '1.8rem' }}>
          <Grid item xs={3}>
            <VCard user={user} />
          </Grid>
        </Grid>
      </Box>
      <Link
        key={1}
        component={RouterLink}
        to={'/'}
        sx={{
          textDecoration: 'underline',
          mt: '-6rem',
        }}>
        <Typography variant='body2'>Powered by The 100 Club</Typography>
      </Link>
    </Grid>
  );
};

export default ProfileLinks;
